import { Pipe, PipeTransform } from '@angular/core';
import { GiftTicketOrderableByEnum } from 'app/core/helpers/enums';
import  * as _ from 'lodash';

@Pipe({
  name: 'orderableByNiceName'
})
export class OrderableByNiceNamePipe implements PipeTransform {

  transform(value: number): string {
    return `ORDERABLE_BY.${GiftTicketOrderableByEnum[value] ? GiftTicketOrderableByEnum[value] : value}`;
  }

}




@Pipe({
  name: 'orderableByGrouping'
})
export class OrderableByGroupingPipe implements PipeTransform {

  transform(data: {orderableBy}[]): {orderableBy}[] {

    if(!data) {
      return [];
    }

    const transformedData = [];

    const isAllEmployees = data.filter( (el) =>
      el.orderableBy === GiftTicketOrderableByEnum['FEMALE_EMPLOYEES'] || el.orderableBy === GiftTicketOrderableByEnum['MALE_EMPLOYEES']).length === 2;

    if (isAllEmployees) {
      transformedData.push({orderableBy: 'ALL_EMPLOYEES', id:-1});
      data = data.filter( (e) =>  (e.orderableBy !== GiftTicketOrderableByEnum['FEMALE_EMPLOYEES'] && e.orderableBy !== GiftTicketOrderableByEnum['MALE_EMPLOYEES']) );
    }


    const isAllBeneficiaries = data.filter( (el) =>
      el.orderableBy === GiftTicketOrderableByEnum['CHILD_BENEFICIARIES'] || el.orderableBy === GiftTicketOrderableByEnum['ADULT_BENEFICIARIES']).length === 2;

    if (isAllBeneficiaries) {
      transformedData.push({orderableBy: 'ALL_BENEFICIARIES', id:-2});
      data = data.filter( (e) => (e.orderableBy !== GiftTicketOrderableByEnum['CHILD_BENEFICIARIES'] && e.orderableBy !== GiftTicketOrderableByEnum['ADULT_BENEFICIARIES']));
    }

    // let returnData = _.merge(transformedData, data);

    transformedData.forEach((v)=> {
      data.push(v);
    });

    return data;
  }

}
